import React from 'react';

import CopyrightIcon from '@mui/icons-material/Copyright';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

import { showLocation, handleKeyDown, isEventTypeWebinar, getPricingDetails } from '@common/Util';

import Content from './components/Content';

const StyledCard = styled(Card)(({ theme }) => ({
  outline: 'none', // reset default
  display: 'flex',
  flexDirection: 'column',
  minHeight: '25vh',
  marginBottom: 2,
  cursor: 'pointer',
  position: 'relative',
  bottom: 0,
  transition: 'bottom 0.1s',
  '&:hover': {
    bottom: '2px'
  },
  '&:focus-visible': {
    outline: `3px solid ${theme.palette.primary.main}`,
    outlineOffset: '2px',
    borderRadius: theme.shape.borderRadius
  },
  [theme.breakpoints.up('sm')]: {
    minHeight: 'inherit',
    flexDirection: 'row'
  }
}));

const PlainCardContentImage = styled(CardMedia)(({ theme, objectFit }) => ({
  display: 'flex',
  backgroundColor: theme.palette.common.white,
  backgroundRepeat: 'no-repeat',
  height: '125px',
  width: '100%',
  objectFit: objectFit || 'cover',
  [theme.breakpoints.up('sm')]: {
    width: '30%',
    height: 'auto'
  },
  [theme.breakpoints.up('md')]: {
    width: '16%'
  }
}));

const StyledBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  color: theme.palette.grey[200],
  paddingLeft: '5px',
  textAlign: 'left',
  lineHeight: 1,
  position: 'absolute',
  top: '120px',
  width: '16%',
  background: theme.palette.primary.background,
  [theme.breakpoints.up('sm')]: {
    bottom: 0,
    top: 'inherit',
    width: '16%'
  }
}));

const EventListItem = ({
  event,
  onItemClick = () => {},
  config,
  memoizedImageSource,
  label,
  showMaxSeats = () => {}
}) => {
  const { eventPrice, eventCurrency } = getPricingDetails(event);

  const handleKey = (e) => {
    handleKeyDown(e, event, onItemClick);
  };
  // console.log('EventListItem render', event?.name);
  return (
    <>
      <Grid item xs={12} key={event.id}>
        <StyledCard
          data-test-id='eventItemContent'
          tabIndex={0}
          onClick={() => onItemClick(event)}
          onKeyDown={handleKey}
        >
          <PlainCardContentImage component='img' src={memoizedImageSource} alt={label} />
          {event?.copyrightInfo && (
            <StyledBox>
              <CopyrightIcon sx={{ fontSize: '0.7rem', mr: 0.5 }} />
              <Typography sx={{ fontSize: '0.7rem' }}>{event?.copyrightInfo}</Typography>
            </StyledBox>
          )}

          <Content
            startDate={event?.startDateTime}
            endDate={event?.endDateTime}
            eventTypeName={event?.type?.value}
            eventName={event?.name}
            config={config}
            languages={event?.nativeLanguages}
            price={eventPrice || ''}
            currency={eventCurrency}
            city={!isEventTypeWebinar(event) && event.city}
            country={!isEventTypeWebinar(event) && event?.country?.value}
            location={`${showLocation(event)}`}
            maxSeats={showMaxSeats(event?.availableSeats, event?.maxParticipants)}
            event={event}
          />
        </StyledCard>
      </Grid>
    </>
  );
};

export default EventListItem;
